export default __webpack_public_path__ + "static/media/FeIcon1.ecf737ac.svg";